export default "__VITE_ASSET__tnTnwEuj__"